<template>
  <div class="card review-section" :class="{ 'p-24': showTitle }">
    <base-section-title v-if="showTitle" :title="title" class="m-b-24" />
    <online-reviewer-setting class="m-b-16" @reloadReview="afterChange" />
    <!--<online-review-expert-group-->
    <!--  :review-id="reviewInfo.reviewId"-->
    <!--  :expert-list="reviewInfo.reviewerInfoList || []"-->
    <!--  :before-start="beforeReviewStart"-->
    <!--  :review-end="reviewClosed"-->
    <!--  :show-operator="showOperator"-->
    <!--  class="m-b-16"-->
    <!--  @addReviewer="afterAddReviewer"-->
    <!--  @afterChange="afterChange"-->
    <!--/>-->
    <online-review-result
      v-if="showResult"
      ref="onlineReviewResultRef"
      :review-id="reviewId"
      :review-closed="reviewClosed"
      :review-list="reviewInfo.wayInfoList"
      :review-project="reviewInfo"
      :has-report="hasReport"
      :show-pdf-dialog="showPdfDialog"
      :result-api="resultApi"
      :offer-unit="offerUnit"
      :purchase-type="purchaseType"
      :is-rank-by-quote="isRankByQuote"
    >
      <template v-slot:headAction>
        <slot name="resultHeadAction"></slot>
      </template>
    </online-review-result>
  </div>
</template>

<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle.vue'
import OnlineReviewResult from '@/components/online-review/review/OnlineReviewResult.vue'
import OnlineReviewerSetting from '@/components/online-review/project/OnlineReviewerSetting.vue'
import { onlineReviewStatusDict } from '@/dictionary/project/online-review'
import { inquiryReviewModelDict } from '@/dictionary/project/inquiry'
import { purchaseTypeDict } from '@/dictionary/project/common'
import { getInquiryReviewRankPageApi } from '@/api/procure/inquiry-review'

/**
 * @description 采购人接受报价页面显示的评审流程板块
 */
export default {
  name: 'InquiryReviewSection',

  components: {
    BaseSectionTitle,
    OnlineReviewResult,
    OnlineReviewerSetting
  },

  props: {
    orderId: {
      type: [String, Number],
      default: 0
    },

    reviewModel: {
      type: Number,
      default: 0
    },

    reviewInfo: {
      type: Object,
      default: () => {}
    },

    // 报价币种
    offerUnit: {
      type: String,
      default: '元'
    },

    title: {
      type: String,
      default: '询比评审'
    },

    purchaseType: {
      type: [Number, String],
      default: purchaseTypeDict.INQUIRY.value
    },

    // 显示标题
    showTitle: {
      type: Boolean,
      default: true
    },

    // 查看报告显示为弹窗展示
    showPdfDialog: {
      type: Boolean,
      default: false
    },

    // 结果接口
    resultApi: {
      type: Function,
      default: getInquiryReviewRankPageApi
    },

    // 是否显示专家操作项，默认显示
    showOperator: {
      type: Boolean,
      default: true
    }
  },

  provide() {
    return {
      provideReviewId: () => this.reviewId,
      provideOrderId: () => this.orderId,
      providePurchaseType: () => this.purchaseType,
      provideReviewProject: () => this.reviewInfo,
      provideBeforeStart: () => this.beforeStart,
      provideReviewClosed: () => this.reviewClosed
    }
  },

  data() {
    return {
      // 是否显示评审结果
      showResult: false,
      // 评审专家列表是否为编辑中
      beforeReviewStart: false
    }
  },

  computed: {
    reviewId() {
      return this.reviewInfo?.reviewId
    },

    beforeStart() {
      const reviewerListEditStatus = [
        onlineReviewStatusDict.INIT.value,
        onlineReviewStatusDict.PENDING.value
      ]
      return reviewerListEditStatus.includes(this.reviewInfo.reviewStatus)
    },

    // 评审结束
    reviewClosed() {
      const endStatus = [
        onlineReviewStatusDict.END.value,
        onlineReviewStatusDict.REPORTED.value
      ]
      return endStatus.includes(this.reviewInfo.reviewStatus)
    },

    hasReport() {
      return this.reviewInfo.reportInfoList?.length > 0
    },

    isRankByQuote() {
      return this.reviewModel === inquiryReviewModelDict.LOWEST_MARK.value
    }
  },

  watch: {
    reviewInfo: {
      handler(val) {
        if (val?.reviewId) {
          const reviewerListEditStatus = [
            onlineReviewStatusDict.INIT.value,
            onlineReviewStatusDict.PENDING.value
          ]
          this.beforeReviewStart = reviewerListEditStatus.includes(
            val?.reviewStatus
          )

          // 仅评审结束和已生成报告展示评审结果
          const showStatus = [
            onlineReviewStatusDict.REVIEWING.value,
            onlineReviewStatusDict.SCORED.value,
            onlineReviewStatusDict.END.value,
            onlineReviewStatusDict.REPORTED.value
          ]

          this.showResult = showStatus.includes(val?.reviewStatus)
        }
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    afterAddReviewer() {
      this.$emit('addReviewer')
    },

    afterChange() {
      this.$emit('afterChange')
    }
  }
}
</script>

<style scoped lang="scss">
.review-section {
  width: 100%;
  overflow: hidden;
}
</style>
